import { render, staticRenderFns } from "./CollapseDirigeantSalaries.vue?vue&type=template&id=785dc4eb&"
import script from "./CollapseDirigeantSalaries.vue?vue&type=script&lang=js&"
export * from "./CollapseDirigeantSalaries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports